<script setup lang="ts">
import { useStore } from "vuex";

import { computed, defineProps } from "vue";
import { PropType } from "@vue/runtime-core";
import { BrandConfig } from "@/struct/BrandsConfigStruct";
import { defaultBrand } from "../../config/brands";

const store = useStore();
const currentRealBrand = computed(() => store.state.brand.operatorSource);
const configDataBrand = computed(() => store.getters["brand/configDataBrand"]);

defineProps({
  testConfigDataBrand: {
    type: Object as PropType<BrandConfig>,
    required: true,
  },
});
</script>

<template>
  <div class="ui-kit-brands">
    <div class="ui-kit-brands__head">
      <span>Brands </span>
    </div>
    <p class="ui-kit-brands__text">
      Дефолтный бренд на сайте (используется в неавторизованной зоне):
      {{ defaultBrand }}.
    </p>
    <p class="ui-kit-brands__text">
      Дефолтный конфиг в store getters: configDataDefaultBrand.
    </p>
    <p class="ui-kit-brands__text">
      Текущий бренд на сайте: {{ currentRealBrand }}
    </p>
    <div class="ui-kit-brands__row --wrap --line">
      <div class="logo-container">
        <p>logo</p>
        <img :src="configDataBrand.assets.logo" alt="Логотип" />
      </div>
      <div class="logo-container">
        <p>logoMobile</p>
        <img :src="configDataBrand.assets.mobileLogo" alt="Логотип" />
      </div>
      <div class="logo-container">
        <p>loader</p>
        <img :src="configDataBrand.assets.loader" alt="Загрузка" />
      </div>
    </div>
    <p class="ui-kit-brands__text">
      Тестовый бренд в UI-KIT: {{ testConfigDataBrand.id }}
    </p>
    <div class="ui-kit-brands__row --wrap --line">
      <div class="name-container">
        Добро пожаловать<br />в {{ testConfigDataBrand.name }}
      </div>
    </div>
    <div class="ui-kit-brands__row --wrap --line">
      <div class="logo-container">
        <p>logo</p>
        <img :src="testConfigDataBrand.assets.logo" alt="Логотип" />
      </div>
      <div class="logo-container">
        <p>logoMobile</p>
        <img :src="testConfigDataBrand.assets.mobileLogo" alt="Логотип" />
      </div>
      <div class="logo-container">
        <p>loader</p>
        <img :src="testConfigDataBrand.assets.loader" alt="Загрузка" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.ui-kit-brands {
  &__head {
    padding: 20px 0 10px;
    font-size: 20px;
    font-weight: bold;
    transition: all 0.4s;
  }
  &__text {
    font-size: 18px;
    margin-top: 15px;
  }
  &__row {
    display: flex;
    flex-direction: column;
    gap: 15px;
    transition: all 0.4s;
    margin-top: 20px;

    &.--line {
      flex-direction: row;
      flex-wrap: nowrap;
      gap: 40px;
      &.--wrap {
        flex-wrap: wrap;
      }
    }
    .logo-container {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }
  }
}
</style>
